// @flow
import AppPolls from './AppPolls';

export default AppPolls;
